var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"motivate-logo-wrapper"},[_c('span',{staticClass:"powered-by-text",on:{"click":function($event){return _vm.openWebsite()}}},[_vm._v("Powered by")]),_vm._v(" "),_c('img',{staticClass:"motivate-logo",attrs:{"src":require("@/assets/Logo-2022-Motivate.png")},on:{"click":function($event){return _vm.openWebsite()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }